import { GraphDocument } from "@features/builder/types"
import { createContext } from "react"

export const GraphDocumentContext = createContext<GraphDocument | undefined>(undefined)
